import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "@/components/app/Layout";
import { api, mediaUrl } from "@/lib/api";
import MasonryGrid from "@/components/app/MasonryGrid";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Share2, Lock, Globe } from "lucide-react";
import { toast } from "sonner";

export default function CollectionDetail() {
  const { id } = useParams();
  const [col, setCol] = useState(null);

  useEffect(() => {
    api.get(`/collections/${id}`).then(({ data }) => setCol(data)).catch(() => setCol({ error: true }));
  }, [id]);

  if (!col) return <Layout><div className="py-24 text-center text-muted-foreground">Loading…</div></Layout>;
  if (col.error) return <Layout><div className="py-24 text-center text-muted-foreground">Collection not found or private.</div></Layout>;

  const share = async () => {
    try { await navigator.clipboard.writeText(window.location.href); toast.success("Link copied"); } catch { toast.error("Copy failed"); }
  };

  return (
    <Layout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="meta-label mb-2 flex items-center gap-2">
          {col.is_public ? <Globe className="h-3 w-3" /> : <Lock className="h-3 w-3" />}
          {col.is_public ? "Public collection" : "Private collection"}
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight" data-testid="collection-title">{col.title}</h1>
        {col.description && <p className="mt-4 text-muted-foreground max-w-2xl">{col.description}</p>}

        <div className="mt-6 flex items-center justify-between gap-4 flex-wrap">
          {col.owner && (
            <Link to={`/u/${col.owner.username}`} className="flex items-center gap-3 group">
              <Avatar className="h-10 w-10"><AvatarImage src={col.owner.avatar_url} /><AvatarFallback>{col.owner.full_name?.[0]}</AvatarFallback></Avatar>
              <div>
                <div className="text-sm font-semibold group-hover:text-[hsl(var(--accent))]">{col.owner.full_name}</div>
                <div className="meta-label">@{col.owner.username}</div>
              </div>
            </Link>
          )}
          <Button variant="outline" onClick={share} data-testid="col-share-btn"><Share2 className="h-4 w-4 mr-2" /> Share</Button>
        </div>

        <div className="mt-10">
          <MasonryGrid projects={col.projects || []} empty="No projects saved to this collection yet." />
        </div>
      </section>
    </Layout>
  );
}
